import DefaultInsurancesFieldset from "app/pages/Booking/Payment/Insurances/InsurancesFieldset";

const InsurancesFieldset = props => {
	return <DefaultInsurancesFieldset {...props} />;
};

export default InsurancesFieldset;
